import { $instance, $shared } from './constants';
export function createViewInstance(config) {
    return {
        [$shared]: {},
        config
    };
}
export function extendViewInstance(// eslint-disable-next-line @typescript-eslint/no-explicit-any
instance, config) {
    var _instance, _$instance;
    const extendedInstance = {
        [$shared]: instance[$shared],
        config
    };
    var _;
    (_ = (_instance = instance)[_$instance = $instance]) !== null && _ !== void 0 ? _ : _instance[_$instance] = extendedInstance;
    return extendedInstance;
}

//# sourceMappingURL=ViewInstance.js.map